
import Vue from 'vue'
import api from 'Api'
import { uuid } from 'vue-uuid'

const URL = '/organization'
const lisenceApiUrl = '/license/organization/'
const state = {
  organizations: [],
  filtered_organizations: [],
  activeOrganization: {},
  _organizationLoadedItems: {
    organizations: false
  },
  organization_loading: false,
  organizationLicenseDetails: null
}

const status = {
  organizationsLoading: false
}

const getters = {
  isAdmin: _state => (userId) => {
    const currentOrganization = localStorage.getItem('reveles-currentOrganization')
    if (currentOrganization) {
      const organization = JSON.parse(currentOrganization)
      const teams = organization.users.find(user => user.user_id === userId).teams
      if (teams != null) {
        return teams.includes('Admin') || teams.includes('Super Admin')
      }
    }
    return false
  },
  organizations: state => {
    return state.organizations
  },
  license: state => {
    return state.organizationLicenseDetails
  },
  organization_loading: state => {
    return state.organization_loading
  },
  filtered_organizations: state => {
    return state.filtered_organizations
  },
  activeOrganization: state => {
    return state.activeOrganization
  },
  _organizationLoadedItems: state => {
    return state._organizationLoadedItems
  }
}

function get (context, URL, handler) {
  return api().get(URL).then(response => handler(context, response))
}

function post (context, URL, data, handler) {
  return api().post(URL, data).then(response => handler(context, response))
}

function put (context, data, handler) {
  return api().put(URL, data).then(response => handler(context, response))
}

function apiDelete (context, URL, id, handler) {
  return api().delete(URL + '/' + id).then(response => handler(context, id, response))
}

function handleOrganizationsLoad (context, response) {
  const organizations = response.data
  status.organizationsLoading = false
  context.commit('setOrganizationLoading', false)
  if (organizations.error) {
    context.commit('apiError', organizations.error)
  } else {
    context.commit('organizationsLoaded', organizations)

    context.dispatch('loadCurrentOrganization')
  }
}

function handleOrganizationSave (context, response) {
  const organization = response.data
  if (organization.error) {
    console.log('save org error')
    context.commit('apiError', organization.error)
  } else {
    console.log('save org success')
    context.commit('organizationSuccess', organization)
  }
}

function handleOrganizationDelete (context, id, response) {
  const organization = response.data
  if (organization.error) {
    context.commit('apiError', organization.error)
  } else {
    context.commit('organizationDeleted', id)
  }
}

function handleActiveOrganizationLoad (context, response) {
  const organization = response.data
  if (organization.error) {
    context.commit('apiError', organization.error)
  } else {
    context.commit('setActiveOrganization', organization)
  }
}

// function addIfPresent (source, destination, propertyName) {
//   if (source[propertyName]) {
//     destination[propertyName] = source[propertyName]
//   }
// }

function replaceOrganization (state, organization) {
  state.organizations = state.organizations.filter(item => item.entity_id !== organization.entity_id)
  state.organizations.push(organization)
  return state.organizations
}

const actions = {
  loadOrganizations (context, payload) {
    if (status.organizationsLoading || state._organizationLoadedItems.organizations) {
      return
    }
    status.organizationsLoading = true
    context.commit('setOrganizationLoading', true)
    return get(context, URL, handleOrganizationsLoad)
  },
  async fetchOrganizationLicense (context, payload) {
    if (!payload) return
    let response = {}
    try {
      response = await api().get(`${lisenceApiUrl}${payload}`)
      context.commit('setLisenceData', response.data)
    } catch (e) {
      console.log('Error:', e)
      // SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
    return response
  },
  saveOrganization (context, payload) {
    const organizationData = {
      version: payload.version,
      entity_id: payload.entity_id,
      name: payload.name,
      domain: payload.domain,
      owner: payload.owner,
      partner: payload.partner,
      band: payload.band,
      contact: payload.contact,
      email: payload.email,
      users: payload.users,
      user_ids: payload.user_ids,
      parent_id: payload.parent_id
    }

    let req
    if (payload.entity_id) {
      req = put(context, organizationData, handleOrganizationSave)
    } else {
      organizationData.entity_id = uuid.v4()
      req = post(context, URL, organizationData, handleOrganizationSave)
    }
    context.commit('updateOrganizationData', organizationData)
    return req
  },
  deleteOrganization (context, id) {
    state.organizations = state.organizations.filter(item => item.entity_id !== id)
    state.filtered_organizations = state.filtered_organizations.filter(item => item.entity_id !== id)
    return apiDelete(context, URL, id, handleOrganizationDelete)
  },
  loadActiveOrganization (context, id) {
    const orgArr = state.organizations.filter(item => item.entity_id === id)
    if (orgArr && orgArr[0]) {
      context.commit('setActiveOrganization', orgArr[0])
    }
    get(context, URL + '/' + id, handleActiveOrganizationLoad)
  }
}

const mutations = {
  setOrganizationLoading (state, status) {
    state.organization_loading = status
  },
  setLisenceData (state, data) {
    state.organizationLicenseDetails = data
  },
  organizationsLoaded (state, organizations) {
    state.organizations = organizations
    state.filtered_organizations = organizations
    state._organizationLoadedItems.organizations = true
  },
  organizationSuccess (state, organization) {
    const organizations = replaceOrganization(state, organization)
    state.organizations = organizations
    state.filtered_organizations = organizations

    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Organization Saved'
    })
  },
  organizationDeleted (state, id) {
    state.organizations = state.organizations.filter(item => item.entity_id !== id)
    state.filtered_organizations = state.filtered_organizations.filter(item => item.entity_id !== id)
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Organization deleted'
    })
  },
  setActiveOrganization (state, organization) {
    state.activeOrganization = organization
  },
  updateOrganizationData (state, organization) {
    const organizations = replaceOrganization(state, organization)
    state.organizations = organizations
    state.filtered_organizations = organizations
  },
  updateFilteredOrganizations (state, organizations) {
    state.filtered_organizations = organizations
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'organizationStore'
}
